<!-- src/components/LayerPage4.vue -->
<template>
  <div class="whole-container">
    <div class="header">
      <h1> Bulk Transcriptomics of Myometrium (proliferative) </h1>
      <div class="function_description">
          <p> Bulk RNA sequencing was performed on myometrium of six adenomyosis samples and five controls using the Illumina Hiseq 2500 sequencing system. Data was from the study of Zhai et al. (DOI: 10.1016/j.rbmo.2022.05.007). </p>
        </div>
    </div>
    <GeneChoose uniqueId="function_4" function_name="function_4" description="Enter a gene to explore its expression in the myometrium of proliferative phase adenomyosis"></GeneChoose>
    <!-- Your content for Page 1 goes here -->
  </div>
</template>

<script>
import GeneChoose from '@/components/GeneChoose.vue';
export default {
  components: {
    GeneChoose,
},
  name: 'PageFour'
}
</script>